import Fade from 'embla-carousel-fade';
import { useEffect } from 'react';
import {
  useCarousel,
  Carousel,
  CarouselProps,
  CarouselSlide,
} from '@/components/carousel';

type FlashcardCarouselProps = CarouselProps & {
  displayIndex?: number;
  slides?: React.ReactNode[];
  onSettle?: () => void;
};

export function FlashcardCarousel({
  displayIndex,
  slides = [],
  onSettle,
  ...others
}: FlashcardCarouselProps) {
  const [carouselRef, carouselApi] = useCarousel(
    {
      displayIndex,
      watchDrag: false,
      watchFocus: false,
    },
    [Fade()]
  );

  useEffect(() => {
    const handleSettle = () => {
      if (onSettle) {
        onSettle();
      }
    };

    if (carouselApi && onSettle) {
      carouselApi.on('settle', handleSettle);
    }

    return () => {
      carouselApi?.off('settle', handleSettle);
    };
  }, [carouselApi, onSettle]);

  return (
    <Carousel {...others} ref={carouselRef}>
      {slides.map((slide, i) => (
        <CarouselSlide key={i}>{slide}</CarouselSlide>
      ))}
    </Carousel>
  );
}
FlashcardCarousel.displayName = 'FlashcardCarousel';
